module.exports = __webpack_public_path__ + "img/menuIcon1.ff2c10c9.png";